import React from 'react';
import { Modal } from '@mantine/core';
import iconClose from './icon-close.svg';
import { ShakkerLoginModal } from '../ShakkerLoginModal/index';
// function getTopLevelDomain(url) {
//   // 使用正则表达式匹配一级域名
//   // eslint-disable-next-line
//   const regex = /^https?:\/\/(?:[^\/]+\.)?([^\.]+\.[^.]+)$/;
//   const matches = url.match(regex);

//   if (matches && matches[1]) {
//     // matches[1] 包含一级域名（例如：art）
//     return matches[1];
//   } else {
//     // 如果没有找到匹配项，返回null或抛出错误
//     return null;
//   }
// }

/**
 * Shakker的登录弹窗
 * @returns
 */
export const ShakkerLogin = (props) => {
  const { onClose, showClose = false } = props;

  return (
    <Modal
      centered={true}
      padding={0}
      size="auto"
      opened={true}
      withCloseButton={showClose}
      closeOnClickOutside={false}
      closeOnEscape={false}
      zIndex="4444"
      radius="xl"
      closeButtonProps={{
        className: 'outline-none',
        children: <img src={iconClose} style={{ height: 32, width: 32 }} />,
        h: 36,
        onClick: (e) => {
          e.stopPropagation();
          onClose && onClose();
        },
        w: 36,
      }}
      onClose={() => {
        onClose && onClose();
      }}
      styles={{
        content: {
          backgroundColor: 'transparent',
          overflow: 'unset !important',
          borderRadius: '26px',
        },
        header: {
          minHeight: 0,
        },
        close: {
          position: 'absolute',
          right: -48,
          top: 0,
          '&:active': {
            backgroundColor: 'unset',
            opacity: 0.8,
          },
          '&:hover': {
            backgroundColor: 'unset',
            opacity: 0.8,
          },
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
        },
      }}
    >
      <ShakkerLoginModal />
    </Modal>
  );
};
